<template>
      <div class="container-fluid">
        <div class="page-title">
            <div class="row main-content">
                <div class="col-xxl-12 col-xl-12 col-md-12 col-6">
                    <h1>Dashboard</h1>        
                </div>
            </div>
        </div>
    </div>
    <div>
          <!-- Tab 切換 -->
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a class="nav-link" :class="{ active: dashboardStore.filter === 'General' }" @click="setActiveTab('General')">General</a>
          </li>
          <li v-if="isAdmin" class="nav-item">
            <a class="nav-link" :class="{ active: dashboardStore.filter === 'Management' }" @click="setActiveTab('Management')">Management</a>
          </li>
          <li v-if="isAdmin" class="nav-item">
            <a class="nav-link" :class="{ active: dashboardStore.filter === 'Card' }" @click="setActiveTab('Card')">Card</a>
          </li>
        </ul>

        <div class="row">
            <KeyMetrics />
            <Active />
            <Terminal />
            <Prepaid />
        </div>
    </div>
</template>

<script setup>
import KeyMetrics from './keyMetrics.vue';
import Active from './Active.vue';
import Terminal from './Terminal.vue';
import Prepaid from './Prepaid.vue';
import { onMounted } from 'vue';
import { useDashboardStore } from '@/store/admin/dashboard';


const dashboardStore = useDashboardStore();

const userInfo = JSON.parse(localStorage.getItem('Admin'));
const isAdmin = userInfo?.role_id === 1 || userInfo?.role_id === 2;

const setActiveTab = async (type) => {
  dashboardStore.filter = type;
  if(type === 'Management'){
    await dashboardStore.fetchManagementDashboard();
  }else if(type === 'Card'){
    // await dashboardStore.fetchCardDashboard();
  }else{
    await dashboardStore.fetchDashboard();
  }
};

onMounted(async()=>{
  await dashboardStore.fetchDashboard();
});

</script> 

<style scoped>
.page-title{
  background-color: #e6e9ec !important;
  margin-bottom: 0px !important;
  padding:  0px !important;
}

.main-content{
  padding: 40px;
  padding-bottom: 20px;
}

.nav-tabs .nav-item {
    margin-bottom: -1px;
  }

  .nav-tabs .nav-link {
    border: 1px solid transparent;
    border-radius: 10px 10px 0px 0px;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  .nav-tabs .nav-link.active {
    border-color: #ddd #ddd #fff;
    background-color: #fff;
    color: #000;
  }


@media (max-width:992px) {

  .main-content{
  padding-top: 70px;
}
}



</style>
